import { required, useAuthenticated } from "react-admin";
import { RouteComponentProps } from "react-router-dom";
import { ReportForm } from "../common/ReportForm";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { DatePicker } from "@material-ui/pickers";
import { RaDriverPicker } from "../../common/form/RaDriverPicker";
import { RaVehiclePicker } from "../../common/form/RaVehiclePicker";

interface Props extends RouteComponentProps {}

export const DvirHistoryReport = (props: Props) => {
  useAuthenticated();

  return (
    <ReportForm
      reportName="dvir-history"
      {...props}
      title="DVIR report"
      submitMethod={(x) => x.reportDvirinspectionsreportPost}
    >
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateFrom"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateTo"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <RaDriverPicker source="driverId" />
      <RaVehiclePicker source="vehicleId" />
    </ReportForm>
  );
};
